import * as EscPosEncoder from "esc-pos-encoder";

// Public class from BitmapConverter cordova plugin
declare let BitmapConverter: any;

/**
 * Utils to generate data for bluetooth printer
 * Use Ionic BluetoothSerial plugin write data directly
 * BluetoothSerial.write()
 */
export class BLPrinterUtils {

    static ALIGN_LEFT = '\x1B\x61\x00';

    static ALIGN_CENTER = '\x1B\x61\x01';

    static ALIGN_RIGHT = '\x1B\x61\x02';
    static CUT_PAPER = '\0x1d\0x56\0x41\0x00';
    /**
     * Generate QR code with content and size by inch
     * Default size is 8 inch
     */
    static createQRCode(content: string, qr_size: string = '\x04', qr_model: string = '\x32'): string {
        // const qr_model = '\x32';          // 31 or 32
        const qr_eclevel = '\x33';          // error correction level (30, 31, 32, 33 - higher)
        const qr_data = content;
        const qr_pL = String.fromCharCode((qr_data.length + 3) % 256);
        const qr_pH = String.fromCharCode((qr_data.length + 3) / 256);
        return '\x1D\x28\x6B\x04\x00\x31\x41' + qr_model + '\x00' +        // Select the model
               '\x1D\x28\x6B\x03\x00\x31\x43' + qr_size +                  // Size of the model
               '\x1D\x28\x6B\x03\x00\x31\x45' + qr_eclevel +               // Set n for error correction
               '\x1D\x28\x6B' + qr_pL + qr_pH + '\x31\x50\x30' + qr_data + // Store data
               '\x1D\x28\x6B\x03\x00\x31\x51\x30';                         // Print
    }

    static createQRCodeEsc(content: string, qr_size: number = 6, qr_model: number = 1) {
      return new EscPosEncoder().qrcode(content, qr_model, qr_size, 'h').encode();
      
    }

    /**
     * Generate image to ByteArray, image path can be url or path
     * Support resize image by printer resolution
     */
    // static createImageByteArray(options: BLImageOptions, success: Function, error: Function) {
    //     alert("i am in create image array")
    //     this.resizeImage(options, (imageBase64) => {
    //         if (imageBase64) {
    //             console.log(imageBase64)

    //             BitmapConverter.convertImageBase64(imageBase64, (base64Print) => {
    //                 const byteArray = this._base64ToByteArray(base64Print);
    //                 success(byteArray);
    //             }, error);
    //         } else {
    //             error('LOAD_IMAGE_FAIL');
    //         }
    //     });
    // }

        /**
     * Generate image to ByteArray, image path can be url or path
     * Support resize image by printer resolution
     */
    static createImageByteArrayPromise(options: BLImageOptions) : Promise<Uint8Array> {


        var cbPromise =  new Promise <Uint8Array> ( async (resolve,reject) => {
       // alert("i am in create image array")

       let imageBase64 = await this.resizeImage(options);

            if (imageBase64) {
                //console.log(imageBase64)
                BitmapConverter.convertImageBase64(imageBase64, (base64Print) => {
                    const byteArray = this._base64ToByteArray(base64Print);
                    resolve(byteArray);
                })
            } 
            else {
               resolve(null)
            }
    })
    return cbPromise;
    }

    /**
     * Load and resize image with maxWidth and maxHeight
     * Image will be convert to base64 url
     */
    static resizeImage(options: BLImageOptions) : Promise<string> {


        var cbPromise =  new Promise <string> ( (resolve,reject) => {

        var image = new Image();
        var c = document.createElement("canvas");
        var ctx = c.getContext("2d");
        image.src = options.dataUrl;

        image.onload = () => {
            let width = image.width;
            let height = image.height;

            if (options.maxWidth || options.maxHeight) {
                options.maxWidth = options.maxWidth || 0;
                options.maxHeight = options.maxHeight || 0;
                // Compute resize
                let scale = Math.max(options.maxWidth / image.width, options.maxHeight / image.height);
                if (scale < 1) {
                    width = Math.round(image.width * scale);
                    height = Math.round(image.height * scale);
                }
            }

            width = 300;
            height = 100;
            c.width = width;
            c.height = height;

            ctx.fillStyle = 'white';
            ctx.fillRect(0, 0, c.width, c.height);

            ctx.drawImage(image, 0, 0, width, height);
            resolve(c.toDataURL('image/png', 1));
        };
        image.onerror = (e) => {
            console.log('Load image failed: ', e);
            resolve(null);
        };
    })
    return cbPromise;
    }

    
    static textSmall(text: string) {
        
      return new EscPosEncoder()
        .size('small')
        .line(text)
        .encode();
    }


    static textNormal(text: string) {
        return '\x1B\x21\x00' + text;
        return new EscPosEncoder()
        .size('normal')
        .line(text)
        .encode();
    }

    static textBold(text: string) {
    return '\x1B\x21\x08' + text;
      return new EscPosEncoder()
        .bold()
        .text(text)
        .encode();
    }

    static textHigher(text: string) {        
        return '\x1B\x21\x10' + text;
        return new EscPosEncoder()
          .size('large')
          .text(text)
          .encode();
      }

    static textItalic(text: string) {
      return new EscPosEncoder()
        .italic()
        .text(text)
        .encode();
    }

    static textUnderline(text: string) {
      return new EscPosEncoder()
        .underline()
        .text(text)
        .encode();
    }


    private static _base64ToByteArray(base64) {
        var binary_string = window.atob(base64);
        var len = binary_string.length;
        var bytes = new Uint8Array(len);
        for (var i = 0; i < len; i++) {
            bytes[i] = binary_string.charCodeAt(i);
        }
        return bytes;
    }
}

export interface BLImageOptions {
    dataUrl: string; // path or base64
    maxWidth?: number; // maxWidth
    maxHeight?: number; // maxHeight
}



// WEBPACK FOOTER //
// ./src/ext_src/BLPrinterUtils.ts